import { create } from 'zustand';
import { shiftsAPI } from '../api/client';

const useShiftsStore = create((set, get) => ({
  activeShifts: [],
  shiftHistory: [],
  loading: false,
  error: null,

  fetchActiveShifts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await shiftsAPI.getActive();
      set({
        activeShifts: response.data.shifts,
        loading: false
      });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Ошибка загрузки смен',
        loading: false
      });
    }
  },

  fetchShiftHistory: async (limit = 50) => {
    set({ loading: true, error: null });
    try {
      const response = await shiftsAPI.getHistory(limit);
      set({
        shiftHistory: response.data.shifts,
        loading: false
      });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Ошибка загрузки истории',
        loading: false
      });
    }
  },

  startShift: async (addressId, selfieFilename = null) => {
    set({ loading: true, error: null });
    try {
      const response = await shiftsAPI.start(addressId, selfieFilename);
      await get().fetchActiveShifts();
      set({ loading: false });
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Ошибка начала смены',
        loading: false
      });
      throw error;
    }
  },

  endShift: async (shiftId, endSelfieFilename = null) => {
    set({ loading: true, error: null });
    try {
      const response = await shiftsAPI.end(shiftId, endSelfieFilename);
      await get().fetchActiveShifts();
      set({ loading: false });
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Ошибка завершения смены',
        loading: false
      });
      throw error;
    }
  },

  hasActiveShift: () => {
    return get().activeShifts.length > 0;
  },

  clearError: () => set({ error: null }),

  // Полный сброс при выходе из системы — чтобы не показывать чужие смены
  reset: () => set({ activeShifts: [], shiftHistory: [], loading: false, error: null }),
}));

export default useShiftsStore;
